import {
    Injectable
} from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class PacerManagerService {
    modeChanges: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    pacingChanges: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null);
    customemessage:BehaviorSubject<any> = new BehaviorSubject<any>(null);

    constructor(
    ) {
    }

    setPacerModeChanges(mode: any) {
        this.modeChanges.next(mode);
    }
    setCustomeMessage(message:any)
    {
        this.customemessage.next(message) ;
    }

    setPacingChanges(isPacing: boolean) {
        this.pacingChanges.next(isPacing);
    }
}
